import { Box, IconButton, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useFormikContext } from 'formik';
import { ERPJobFormValues } from '@/raptorjob/presentation/ERPJobValidationSchema';
import { ExtraSystemRow } from './ExtraSystemRow';
import tid from '@/common/infrastructure/config/tid';

export function ExtraSystemsSection() {
  const { values, setFieldValue } = useFormikContext<ERPJobFormValues>();

  const addExtraSystem = () => {
    const newExtraSystem = {
      id: `extra-system-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      extraSystemId: null,
      name: null
    };
    const currentExtraSystems = values.extraSystems || [];
    setFieldValue('extraSystems', [...currentExtraSystems, newExtraSystem]);
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 700 }}>
          Line Items
        </Typography>
        <IconButton onClick={addExtraSystem} {...tid('jobs:create:add-extra-system-button')}>
          <AddCircleOutlineIcon color="primary" />
        </IconButton>
      </Box>

      {values.extraSystems && values.extraSystems.length > 0 && (
        <Box>
          {values.extraSystems.map((extraSystem, index) => (
            <ExtraSystemRow key={`${index}-${extraSystem.id}`} index={index} rowId={extraSystem.id} />
          ))}
        </Box>
      )}
    </>
  );
}
